import CreditCard from './creditcardForm/CreditCard'
import CreditCardUpdate from './creditcardForm/CreditCardUpdate'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import FastQuote from './FastQuote/FastQuote'
import TechPartnerDashboard from './TechPartner/TechPartnerDashboard/TechPartnerDashboard'
import TechPartnerQuotaImport from './TechPartner/TechPartnerQuotaImport/TechPartnerQuotaImport'
import EDIForms from './EDIForms/EDIForms'
import { HomePage } from './LCMForms/Components/HomePage'
import { ShopMonitor } from './LCMForms/Components/ShopMonitor'
import { CorrectUIDAssetType } from './LCMForms/Components/CorrectUIDAssetType'
import './fonts.css'
import './global.css'
// import { PointOfSaleManagerDashboard } from './PointOfSaleManager/Components/Dashboard'
import PointOfSaleManager from './PointOfSaleManager/PointOfSaleManager'
import { Components } from './stories/Components'
import { LandingPage } from './LandingPage'
import CategoryForms from './CategoryForms/CategoryForms'
import '../src/FormGenericHooks/index.js'

import { useEffect } from 'react'
import ARContextFrame from './ARAging/ARContextFrame'
import AssemblySearch from './AssemblySearch/AssemblySearch'
import { LOBupload } from './LOBupload/Components/Page/LOBupload'
import { VendorInventoryUpload } from './import/VendorInventoryUpload/VendorInventoryUpload'
import { ImportCommissionOrders } from './import/ImportCommissionOrders/ImportCommissionOrders'

import { FormGenericRoutesWrapper } from './routerFormGenericWrapper'

export default function Router() {
    useEffect(() => {
        window.addEventListener('error', (e) => {
            if (
                e.message !== 'ResizeObserver loop limit exceeded' &&
                e.message !== 'ResizeObserver loop completed with undelivered notifications.' &&
                e.message !== 'Script error.'
            )
                return

            document
                .getElementById('webpack-dev-server-client-overlay-div')
                ?.setAttribute('style', 'display: none')

            document
                .getElementById('webpack-dev-server-client-overlay')
                ?.setAttribute('style', 'display: none')
        })
    }, [])

    return (
        <BrowserRouter>
            <Routes>
                {/* Landing page */}
                <Route path='awcreact' element={<LandingPage />} />

                {/* Fast Quote */}
                <Route path='page/order/:orderNumber' element={<FastQuote />} />
                <Route path='fastquote' element={<FastQuote />} />

                <Route path='dashboard'>
                    {/* Tech Partner Dashboard */}
                    <Route path='techpartner' element={<TechPartnerDashboard />} />
                    {/* AR Aging Dashboard */}
                    <Route path='araging' element={<ARContextFrame />} />
                    {/* Assembly Search */}
                    <Route path='assemblysearch' element={<AssemblySearch />} />
                </Route>

                {/* LCMForms */}
                <Route path='lcmforms'>
                    <Route path='' element={<HomePage />} />
                    <Route path='ShopMonitor' element={<ShopMonitor />} />
                    <Route path='CorrectUIDAssetType' element={<CorrectUIDAssetType />} />
                </Route>

                {/* EDIForms */}
                <Route path='ediformsreact' element={<EDIForms />} />

                {/* Point Of Sale Report Manager */}
                <Route path='pointofsalemanager' element={<PointOfSaleManager />} />

                {/* File Imports */}
                <Route path='import'>
                    {/* Tech Partner Sales Quota Import */}
                    <Route path='TechPartnerQuota' element={<TechPartnerQuotaImport />} />
                    {/* LOB upload */}
                    <Route path='lobupload/' element={<LOBupload />} />
                    {/* Vendor Inventory File Upload */}
                    <Route path='VendorInventoryUpload' element={<VendorInventoryUpload />} />
                    {/* Commission Orders Upload */}
                    <Route path='commissions' element={<ImportCommissionOrders />} />
                </Route>

                {/* CreditCardForm */}
                <Route path='page/creditcard'>
                    <Route
                        path='add/:database/:contactId/:customerId/:quoteNumber/:returnPage/:cancelPage?'
                        element={<CreditCard requestType='add' />}
                    />
                    <Route
                        path='update/:database/:token/:expirationDate/:name/:last4'
                        element={<CreditCardUpdate />}
                    />
                </Route>

                {/* Components */}
                <Route path='components' element={<Components />} />

                {/* Category Forms */}
                <Route path='categoryforms/' element={<CategoryForms />} />

                {/* Forms Generic Hook */}
                <Route path='FormGeneric/*' element={<FormGenericRoutesWrapper />}/>
                    
                
            </Routes>
        </BrowserRouter>
    )
}
